module.exports = __webpack_public_path__ + "media/img/pages/companies/mikron_automat-1684225305699e022c0e79dfef8bfea2.webp";